import styled from "styled-components";
import { Box } from '@usap/uicomponents'

const toastBgColor = props => props.theme.global.colors['white'];

export const MainContainer = styled(Box)`
    flex-direction: row;
    padding: 16px;
    border: 2px solid ${({borderColor}) => borderColor};
    border-radius: 8px;
    margin: 8px 0;
    background: ${toastBgColor};
`
